
export default {
    props: {
        value: Array,
        highlightsColors: Object
    },
    data () {
        return {
            filters: this.value
        }
    },
    watch: {
        filters () {
            this.$emit('input', this.filters)
        }
    },
    methods: {
        getClasses (color, isSelected) {
            const classes = []
            classes.push(color === 'note' ? 'p-2.5' : 'p-3')
            if (isSelected) {
                classes.push(this.highlightsColors[color].selectedClass)
            } else {
                classes.push('bg-white')
            }

            return classes.join(' ')
        }
    }
}
